import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { RippleModule } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-mobile-add-vehicle-button-block',
  standalone: true,
  imports: [ButtonModule, RippleModule],
  templateUrl: './mobile-add-vehicle-button-block.component.html',
  styleUrl: './mobile-add-vehicle-button-block.component.scss'
})
export class MobileAddVehicleButtonBlockComponent implements OnChanges {
  @Input() selectedVehicle: any;
  @Input() disabled: boolean = false;
  @Output() openAddVehicleBottomSheetEvent: EventEmitter<any> = new EventEmitter<any>(); 

  constructor(private cdr: ChangeDetectorRef){

  }
  public addVehicleBottomSheetOpened: boolean = false;

  public openMobileBottomSheet(){
    this.openAddVehicleBottomSheetEvent.emit();
  }

    ngOnChanges(changes: SimpleChanges): void {
      if('selectedVehicle' in changes){
        this.selectedVehicle = changes['selectedVehicle'].currentValue;
      }
      this.cdr.markForCheck();
    }
}
